export default __webpack_public_path__ + "static/media/goodreadsImport@2x.e0b748e8.png";